import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { EditCardComponent } from './edit-card/edit-card.component';
import { AddSecondProductComponent } from './add-second-product/add-second-product.component';
import { CardService } from '../card.service';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialDesignModule } from '../../../shared/material-design/material-design.module';
import { UploadPhotoComponent } from './upload-photo/upload-photo.component';
import { UpdateTitleComponent } from './update-title/update-title.component';
import { UpdateUspsComponent } from './update-usps/update-usps.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MaterialDesignModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    EditCardComponent
  ],
  declarations: [
    EditCardComponent,
    AddSecondProductComponent,
    UploadPhotoComponent,
    UpdateTitleComponent,
    UpdateUspsComponent,
  ],
  providers: [
    CardService
  ],
  exports: [
    EditCardComponent,
  ]
})
export class ModifyCardModule { }



// WEBPACK FOOTER //
// /app/src/app/hq/cards/modify-card/modify-card.module.ts